import React, { useState, useEffect } from "react";
import { Form, Select } from "antd";
import FormModal from "../../../components/FormModal";
import { updateUser } from "./SkeyeingestUsersAPI";
import { extractMsg } from "../../../utils/errorUtils";

const ROLE_OPTIONS = [
  { label: "Admin", value: "admin" },
  { label: "Guest", value: "guest" },
  { label: "Creator", value: "creator" },
  { label: "Manager", value: "manager" },
];

const GROUP_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Dev", value: "dev" },
  { label: "Test", value: "test" },
];

export default function SkeyeingestEditUserDialog({
  open,
  user,
  onClose,
  onSuccess,
  messageApi,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && user) {
      form.setFieldsValue({
        userId: user.name,
        roles: user.roles || [],
        groups: user.groups || [],
      });
    }
  }, [open, user, form]);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await updateUser({
        userId: user.name,
        roles: values.roles || [],
        groups: values.groups || [],
      });
      messageApi.success("User successfully updated.");
      onSuccess();
      onClose();
    } catch (error) {
      messageApi.error({
        content: extractMsg(error, "Failed to update user"),
        key: "update-user-error",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormModal
      title={`Edit User: ${user?.name}`}
      open={open}
      onClose={onClose}
      onFinish={handleFinish}
      loading={loading}
      form={form}
      submitText="Update User"
    >
      <Form.Item
        name="roles"
        label="Roles"
        rules={[{ required: true, message: "Select at least one role" }]}
      >
        <Select
          mode="multiple"
          options={ROLE_OPTIONS}
          placeholder="Select Roles"
        />
      </Form.Item>
      <Form.Item
        name="groups"
        label="Groups"
        rules={[{ required: true, message: "Select at least one group" }]}
      >
        <Select
          mode="multiple"
          options={GROUP_OPTIONS}
          placeholder="Select Groups"
        />
      </Form.Item>
    </FormModal>
  );
}
